import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { errorCopy } from '@/Pages/Error/copy';
import { COMMON_NAMESPACE } from '@/i18n';
import '@/Pages/Error/ErrorPage.sass';

type ErrorActionsProps = {
  showRetry: boolean;
  isRetrying: boolean;
  onRetry: () => void;
  onHome: () => void;
  onSupport: () => void;
};

export function ErrorActions({
  showRetry,
  isRetrying,
  onRetry,
  onHome,
  onSupport,
}: ErrorActionsProps): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Box className="error-actions" data-testid="error-actions">
      {showRetry ? (
        <Button
          type="button"
          variant="contained"
          color="primary"
          fullWidth
          disabled={isRetrying}
          aria-busy={isRetrying}
          loading={isRetrying}
          className="error-actions__retry"
          data-testid="error-actions-retry"
          loadingIndicator={
            <CircularProgress
              size={22}
              aria-label={t('loading')}
              className="error-actions__loader"
            />
          }
          loadingPosition="end"
          onClick={onRetry}
        >
          {errorCopy.actions.retry}
        </Button>
      ) : null}

      <Button
        type="button"
        variant={showRetry ? 'outlined' : 'contained'}
        color="primary"
        fullWidth
        disabled={isRetrying}
        className="error-actions__home"
        data-testid="error-actions-home"
        onClick={onHome}
      >
        {errorCopy.actions.home}
      </Button>

      <Button
        type="button"
        variant="text"
        color="primary"
        disabled={isRetrying}
        className="error-actions__support"
        data-testid="error-actions-support"
        onClick={onSupport}
      >
        {errorCopy.actions.support}
      </Button>
    </Box>
  );
}
